export const packages = [
  {
    value: 'standard',
    version: 'V1.0',
    name: 'Standard',
    price: 246,
    ceilingHeight: '8ft',
    description: 'Quality construction with essential features',
    features: [
      '8ft Ceiling Height',
      '800-1200 SQFT',
      'JM (White) Fiberglass Insulation',
      'Copper Water Supply Pipe',
      '5/8" Drywall',
      'Double Window',
      'Dunn Edwards Paint',
      '100Amp Electrical Panel',
      'Shingle Roofing',
      'Standard Doors',
      '6.5mm Vinyl Flooring',
      'American Style Cabinets',
      'Standard Range Hood',
      'Stovetop (no oven)',
      'Standard Toilet',
      'LED Light',
      'Mini Split AC'
    ],
    detailedItems: {
      structure: [
        { item: 'Foundation', spec: 'Concrete slab foundation with rebar reinforcement' },
        { item: 'Framing', spec: '2x4/6 wood framing, 16" on center' },
        { item: 'Ceiling Height', spec: '8ft standard ceiling' },
        { item: 'Roof Structure', spec: 'Engineered trusses with plywood sheathing' },
        { item: 'Exterior Walls', spec: 'Stucco finish over moisture barrier' }
      ],
      insulation: [
        { item: 'Wall Insulation', spec: 'JM (White) Fiberglass R-19' },
        { item: 'Ceiling Insulation', spec: 'JM (White) Fiberglass R-38' },
        { item: 'Floor Insulation', spec: 'R-19 (if raised foundation)' }
      ],
      electrical: [
        { item: 'Electrical Panel', spec: '100 Amp main panel' },
        { item: 'Outlets', spec: 'Standard 15A/20A outlets per code' },
        { item: 'Lighting', spec: 'LED recessed lights throughout' },
        { item: 'Smoke/CO Detectors', spec: 'Hardwired with battery backup' }
      ],
      plumbing: [
        { item: 'Water Supply', spec: 'Copper piping throughout' },
        { item: 'Drain Lines', spec: 'ABS/PVC drainage system' },
        { item: 'Water Heater', spec: 'Tankless water heater' },
        { item: 'Toilet', spec: 'Standard elongated toilet' }
      ],
      interior: [
        { item: 'Drywall', spec: '5/8" drywall, taped and textured' },
        { item: 'Paint', spec: 'Dunn Edwards interior paint, 2 coats' },
        { item: 'Flooring', spec: '6.5mm vinyl plank flooring' },
        { item: 'Interior Doors', spec: 'Standard hollow-core doors' },
        { item: 'Trim', spec: 'Painted MDF baseboards and casings' }
      ],
      kitchen: [
        { item: 'Cabinets', spec: 'American style shaker cabinets' },
        { item: 'Countertops', spec: 'Engineered Quartz Countertop' },
        { item: 'Sink', spec: 'Stainless steel single-bowl sink' },
        { item: 'Range Hood', spec: 'Standard 30" range hood' },
        { item: 'Cooktop', spec: '4-burner gas stovetop (no oven)' }
      ],
      bathroom: [
        { item: 'Vanity', spec: '30" vanity with countertop' },
        { item: 'Toilet', spec: 'Standard one-piece toilet' },
        { item: 'Shower/Tub', spec: 'Fiberglass tub/shower combo' },
        { item: 'Fixtures', spec: 'Chrome finish faucets' }
      ],
      hvac: [
        { item: 'Heating/Cooling', spec: 'Mini split system (1-2 zones)' },
        { item: 'Ventilation', spec: 'Bathroom exhaust fan' }
      ],
      exterior: [
        { item: 'Windows', spec: 'Double-pane vinyl windows' },
        { item: 'Entry Door', spec: 'Standard insulated entry door' },
        { item: 'Roofing', spec: 'Architectural shingle roofing' },
        { item: 'Gutters', spec: 'Aluminum gutters and downspouts' }
      ]
    }
  },
  {
    value: 'premium',
    version: 'V2.0',
    name: 'Premium',
    price: 256,
    ceilingHeight: '9ft',
    description: 'Upgraded materials and enhanced features',
    features: [
      '9ft Ceiling Height',
      '800-1200 SQFT',
      'JM (White) Fiberglass Insulation',
      'Copper Water Supply Pipe',
      '5/8" Drywall',
      'Double Window',
      'Dunn Edwards Paint',
      '100Amp Electrical Panel',
      'Shingle Roofing',
      'Standard Doors',
      '6.5mm Vinyl Flooring',
      'American Style Cabinets',
      'Stone Splash',
      'High-power Range Hood',
      'Stove with Oven',
      'One-piece Toilet x2',
      'LED Light',
      'Mini Split AC'
    ],
    detailedItems: {
      structure: [
        { item: 'Foundation', spec: 'Concrete slab foundation with rebar reinforcement' },
        { item: 'Framing', spec: '2x4/6 wood framing, 16" on center' },
        { item: 'Ceiling Height', spec: '9ft ceiling throughout' },
        { item: 'Roof Structure', spec: 'Engineered trusses with plywood sheathing' },
        { item: 'Exterior Walls', spec: 'Stucco finish over moisture barrier' }
      ],
      insulation: [
        { item: 'Wall Insulation', spec: 'JM (White) Fiberglass R-19' },
        { item: 'Ceiling Insulation', spec: 'JM (White) Fiberglass R-38' },
        { item: 'Floor Insulation', spec: 'R-19 (if raised foundation)' }
      ],
      electrical: [
        { item: 'Electrical Panel', spec: '100 Amp main panel' },
        { item: 'Outlets', spec: 'Standard 15A/20A outlets per code' },
        { item: 'Lighting', spec: 'LED recessed lights throughout' },
        { item: 'Smoke/CO Detectors', spec: 'Hardwired with battery backup' },
        { item: 'USB Outlets', spec: 'USB outlets in kitchen and bedroom' }
      ],
      plumbing: [
        { item: 'Water Supply', spec: 'Copper piping throughout' },
        { item: 'Drain Lines', spec: 'ABS/PVC drainage system' },
        { item: 'Water Heater', spec: '50-gallon tank water heater' },
        { item: 'Toilets', spec: 'One-piece toilets x2' }
      ],
      interior: [
        { item: 'Drywall', spec: '5/8" drywall, smooth finish' },
        { item: 'Paint', spec: 'Dunn Edwards premium paint, 2 coats' },
        { item: 'Flooring', spec: '6.5mm vinyl plank flooring' },
        { item: 'Interior Doors', spec: 'Solid-core interior doors' },
        { item: 'Trim', spec: 'Painted MDF baseboards and casings' }
      ],
      kitchen: [
        { item: 'Cabinets', spec: 'American style soft-close cabinets' },
        { item: 'Countertops', spec: 'Quartz countertops' },
        { item: 'Backsplash', spec: 'Stone tile backsplash' },
        { item: 'Sink', spec: 'Stainless steel undermount sink' },
        { item: 'Range Hood', spec: 'High-power 36" range hood' },
        { item: 'Range', spec: 'Gas range with oven' }
      ],
      bathroom: [
        { item: 'Vanity', spec: '36" vanity with quartz top' },
        { item: 'Toilets', spec: 'One-piece elongated toilets x2' },
        { item: 'Shower', spec: 'Tile shower with glass door' },
        { item: 'Fixtures', spec: 'Brushed nickel faucets' }
      ],
      hvac: [
        { item: 'Heating/Cooling', spec: 'Mini split system (2 zones)' },
        { item: 'Ventilation', spec: 'Quiet bathroom exhaust fans' }
      ],
      exterior: [
        { item: 'Windows', spec: 'Double-pane vinyl windows, Low-E' },
        { item: 'Entry Door', spec: 'Upgraded insulated entry door' },
        { item: 'Roofing', spec: 'Architectural shingle roofing' },
        { item: 'Gutters', spec: 'Aluminum gutters and downspouts' }
      ]
    }
  },
  {
    value: 'luxury',
    version: 'V3.0',
    name: 'Luxury',
    price: 266,
    ceilingHeight: '9ft + Vaulted',
    description: 'High-end finishes and luxury amenities',
    features: [
      '9ft + Vaulted Ceiling',
      '800-1200 SQFT',
      'JM (White) Fiberglass Insulation',
      'Copper Water Supply Pipe',
      '5/8" Drywall',
      'Double Window',
      'Dunn Edwards Paint',
      '100-200Amp Electrical Panel',
      'Shingle or Tile Roofing',
      'Luxury Black Metal Door',
      'Luxury 82" Interior Door',
      '8.0mm Vinyl Flooring',
      'European Style Cabinets',
      'Stone Splash',
      'FOTILE Range Hood',
      'Stove with Oven',
      'Smart Toilet x2',
      'LED Light',
      'Central AC'
    ],
    detailedItems: {
      structure: [
        { item: 'Foundation', spec: 'Reinforced concrete slab with vapor barrier' },
        { item: 'Framing', spec: '2x4/6 wood framing, 16" on center' },
        { item: 'Ceiling Height', spec: '9ft + vaulted ceiling in living area' },
        { item: 'Roof Structure', spec: 'Engineered trusses for vaulted ceiling' },
        { item: 'Exterior Walls', spec: 'Premium stucco with accent details' }
      ],
      insulation: [
        { item: 'Wall Insulation', spec: 'JM (White) Fiberglass R-21' },
        { item: 'Ceiling Insulation', spec: 'JM (White) Fiberglass R-38' },
        { item: 'Floor Insulation', spec: 'R-19 (if raised foundation)' }
      ],
      electrical: [
        { item: 'Electrical Panel', spec: '100-200 Amp main panel' },
        { item: 'Outlets', spec: 'Premium 15A/20A outlets' },
        { item: 'Lighting', spec: 'LED recessed + pendant fixtures' },
        { item: 'Smoke/CO Detectors', spec: 'Interconnected smart detectors' },
        { item: 'USB Outlets', spec: 'USB-C outlets throughout' }
      ],
      plumbing: [
        { item: 'Water Supply', spec: 'Copper piping throughout' },
        { item: 'Drain Lines', spec: 'ABS/PVC drainage system' },
        { item: 'Water Heater', spec: 'Tankless water heater' },
        { item: 'Toilets', spec: 'Smart toilets x2 (bidet, heated seat)' }
      ],
      interior: [
        { item: 'Drywall', spec: '5/8" drywall, smooth finish' },
        { item: 'Paint', spec: 'Dunn Edwards designer paint, 2 coats' },
        { item: 'Flooring', spec: '8.0mm luxury vinyl plank' },
        { item: 'Interior Doors', spec: 'Luxury 82" solid-core doors' },
        { item: 'Trim', spec: 'Painted wood baseboards and casings' }
      ],
      kitchen: [
        { item: 'Cabinets', spec: 'European style soft-close cabinets' },
        { item: 'Countertops', spec: 'Premium quartz countertops' },
        { item: 'Backsplash', spec: 'Designer stone tile backsplash' },
        { item: 'Sink', spec: 'Workstation sink with accessories' },
        { item: 'Range Hood', spec: 'FOTILE range hood' },
        { item: 'Range', spec: 'Professional gas range with oven' }
      ],
      bathroom: [
        { item: 'Vanity', spec: '48" floating vanity with quartz' },
        { item: 'Toilets', spec: 'Smart toilets x2' },
        { item: 'Shower', spec: 'Frameless glass shower, rain head' },
        { item: 'Fixtures', spec: 'Premium matte black fixtures' }
      ],
      hvac: [
        { item: 'Heating/Cooling', spec: 'Central AC system' },
        { item: 'Ventilation', spec: 'Premium bathroom exhaust fans' },
        { item: 'Air Quality', spec: 'HEPA filtration system' }
      ],
      exterior: [
        { item: 'Windows', spec: 'Double-pane aluminum windows' },
        { item: 'Entry Door', spec: 'Luxury black metal entry door' },
        { item: 'Roofing', spec: 'Tile roofing (or premium shingle)' },
        { item: 'Gutters', spec: 'Seamless aluminum gutters' }
      ]
    }
  },
  {
    value: 'smart',
    version: 'V4.0',
    name: 'Smart Luxury',
    price: 346,
    ceilingHeight: '9ft + Vaulted',
    description: 'Fully integrated smart home technology',
    features: [
      'All V3.0 Features',
      'Smart Lock',
      'Security Camera System',
      'Smart Faucet',
      'Smart Switch',
      'Smart Outlet',
      'Venting Skylight',
      'Custom Built Foldable Bed'
    ],
    smartFeatures: true,
    detailedItems: {
      structure: [
        { item: 'Foundation', spec: 'Reinforced concrete slab with vapor barrier' },
        { item: 'Framing', spec: '2x4/6 wood framing, 16" on center' },
        { item: 'Ceiling Height', spec: '9ft + vaulted ceiling with skylight' },
        { item: 'Roof Structure', spec: 'Engineered trusses with skylight opening' },
        { item: 'Exterior Walls', spec: 'Premium stucco with modern details' }
      ],
      insulation: [
        { item: 'Wall Insulation', spec: 'JM (White) Fiberglass R-21' },
        { item: 'Ceiling Insulation', spec: 'JM (White) Fiberglass R-38' },
        { item: 'Floor Insulation', spec: 'R-19 (if raised foundation)' }
      ],
      electrical: [
        { item: 'Electrical Panel', spec: '200 Amp smart panel' },
        { item: 'Smart Outlets', spec: 'Wi-Fi enabled outlets throughout' },
        { item: 'Smart Switches', spec: 'Programmable dimmer switches' },
        { item: 'Lighting', spec: 'Smart LED recessed + pendant fixtures' },
        { item: 'Smoke/CO Detectors', spec: 'Smart interconnected detectors' }
      ],
      plumbing: [
        { item: 'Water Supply', spec: 'Copper piping throughout' },
        { item: 'Drain Lines', spec: 'ABS/PVC drainage system' },
        { item: 'Water Heater', spec: 'Smart tankless water heater' },
        { item: 'Smart Faucet', spec: 'Touchless kitchen faucet' },
        { item: 'Toilets', spec: 'Smart toilets x2' }
      ],
      interior: [
        { item: 'Drywall', spec: '5/8" drywall, smooth finish' },
        { item: 'Paint', spec: 'Dunn Edwards designer paint' },
        { item: 'Flooring', spec: '8.0mm luxury vinyl plank' },
        { item: 'Interior Doors', spec: 'Luxury 82" solid-core doors' },
        { item: 'Foldable Bed', spec: 'Custom built Murphy bed system' }
      ],
      kitchen: [
        { item: 'Cabinets', spec: 'European style soft-close cabinets' },
        { item: 'Countertops', spec: 'Premium quartz countertops' },
        { item: 'Backsplash', spec: 'Designer stone tile backsplash' },
        { item: 'Sink', spec: 'Workstation sink + smart faucet' },
        { item: 'Range Hood', spec: 'FOTILE range hood' },
        { item: 'Range', spec: 'Professional gas range with oven' }
      ],
      bathroom: [
        { item: 'Vanity', spec: '48" floating vanity with quartz' },
        { item: 'Toilets', spec: 'Smart toilets x2' },
        { item: 'Shower', spec: 'Frameless glass, smart shower system' },
        { item: 'Fixtures', spec: 'Premium matte black fixtures' }
      ],
      hvac: [
        { item: 'Heating/Cooling', spec: 'Smart central AC system' },
        { item: 'Thermostat', spec: 'Smart thermostat with app control' },
        { item: 'Ventilation', spec: 'Smart bathroom exhaust fans' }
      ],
      exterior: [
        { item: 'Windows', spec: 'Double-pane aluminum windows' },
        { item: 'Skylight', spec: 'Motorized venting skylight' },
        { item: 'Entry Door', spec: 'Luxury door with smart lock' },
        { item: 'Roofing', spec: 'Tile roofing' },
        { item: 'Security', spec: '4K camera system with NVR' }
      ],
      smartHome: [
        { item: 'Smart Hub', spec: 'Central smart home controller' },
        { item: 'Smart Lock', spec: 'Keypad + app controlled entry' },
        { item: 'Cameras', spec: '4K security camera system' },
        { item: 'Smart Switches', spec: 'All light switches' },
        { item: 'Smart Outlets', spec: 'Kitchen + living area' },
        { item: 'Voice Control', spec: 'Alexa/Google compatible' }
      ]
    }
  }
];

export const upgrades = [
  {
    category: 'Electrical',
    value: 'electrical_upgrade',
    label: '200Amp Panel Upgrade',
    description: 'Upgrade from 100Amp to 200Amp electrical panel',
    price: 2500
  },
  {
    category: 'Roofing',
    value: 'roofing_upgrade',
    label: 'Tile Roofing Upgrade',
    description: 'Upgrade from shingle to tile roofing',
    price: 3500
  },
  {
    category: 'Interior Door',
    value: 'interior_door_upgrade',
    label: 'Luxury Interior Door',
    description: 'Upgrade to 82" luxury interior doors',
    price: 1200
  },
  {
    category: 'Smart Home',
    value: 'smart_home_package',
    label: 'Smart Home Package',
    description: 'Smart locks, switches, outlets, and camera system',
    price: 5000
  },
  {
    category: 'Kitchen',
    value: 'fotile_hood',
    label: 'FOTILE Range Hood',
    description: 'Upgrade to FOTILE brand range hood',
    price: 1800
  },
  {
    category: 'Bathroom',
    value: 'smart_toilet',
    label: 'Smart Toilet Upgrade',
    description: 'Upgrade to smart toilets (x2)',
    price: 2000
  },
  {
    category: 'HVAC',
    value: 'central_ac',
    label: 'Central AC Upgrade',
    description: 'Upgrade from Mini Split to Central AC',
    price: 4500
  },
  {
    category: 'Flooring',
    value: 'premium_flooring',
    label: 'Premium Vinyl Flooring',
    description: 'Upgrade to 10mm thick vinyl flooring',
    price: 1500
  }
];

export const additionalOptions = [
  {
    value: 'solar_panels',
    label: 'Solar Panels',
    description: 'Complete solar panel system',
    price: 12000,
    category: 'Energy'
  },
  {
    value: 'garage',
    label: 'Garage Addition',
    description: 'Price per square foot',
    pricePerSqft: 200,
    category: 'Structure',
    requiresSquareFootage: true
  },
  {
    value: 'balcony',
    label: 'Balcony Addition',
    description: 'Price per square foot',
    pricePerSqft: 180,
    category: 'Structure',
    requiresSquareFootage: true
  },
  {
    value: 'extra_bathroom',
    label: 'Additional Bathroom',
    description: 'Add one extra bathroom',
    price: 18000,
    category: 'Plumbing'
  }
];
